export default {
  feedback: {
    title: 'Your feedback',
    catch: 'Your opinion is precious!',
    explain: 'Share your feedback with us. All your comments and ratings challenge us to continuously improve WebOptis.',
    comment: 'Comment',
    send: 'Send your feedback',
    privacy: 'Your feedback is anonymous. No personal data is linked with your rating and comment.',
    success: 'Thanks for your feedback!'
  }
}
